import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { eventCommunicator } from '../../../../../../../communicators/eventCommunicator'

import { setDateQueryParam } from '../../../../../../../config/functions'

import { SectionTitle } from '../../../../../../components/SectionTitle/SectionTitle'
import { ErrorBoundary } from '../../../../../../components/ErrorBoundary/ErrorBoundary'
import { DetailsLink } from '../../../../../../components/DetailsLink/DetailsLink'
import { RelatedEventsList } from './RelatedEventsList/RelatedEventsList'

import './RelatedEvents.css'

class RelatedEvents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            relatedEventsList: []
        }
    }

    componentDidMount() {
        this.loadEvents()
    }

    onShowAllEvents = () => {
        this.props.history.push('/dogadjaji')
    }

    async loadEvents() {
        try {
            const { association, sector } = this.props.article
            const eventsData = await eventCommunicator.fetchRelatedEvents(
                setDateQueryParam(0, true),
                {
                    association_id: association ? association.id : null,
                    sector_id: sector ? sector.id : null
                }
            )

            const relatedEventsList = eventsData.events

            this.setState({ relatedEventsList })
        } catch (error) {
            console.error(error.message)
        }
    }

    render() {
        const { t } = this.props
        const { relatedEventsList } = this.state

        if (!relatedEventsList.length) {
            return null
        }

        return (
            <div className="related-events">
                <div className="related-events__title section-title-centered">
                    <SectionTitle title={t('singleArticle.relatedEvents.title')} underlineClass />
                </div>
                {relatedEventsList.length > 0 && (
                    <ErrorBoundary>
                        <RelatedEventsList relatedEventsList={relatedEventsList} />
                    </ErrorBoundary>
                )}
                <DetailsLink
                    text={t('singleArticle.relatedEvents.details')}
                    onDetailsClick={this.onShowAllEvents}
                />
            </div>
        )
    }
}

RelatedEvents.propTypes = {
    t: PropTypes.func,
    associationId: PropTypes.number
}

export { RelatedEvents }
export default withTranslation()(withRouter(RelatedEvents))
